import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconArrowUpLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m11.25 7.373-5.17 5.17a.705.705 0 0 1-.521.22.744.744 0 0 1-.532-.236.784.784 0 0 1-.225-.527.699.699 0 0 1 .225-.527l6.34-6.34A.827.827 0 0 1 12 4.877a.828.828 0 0 1 .633.256l6.34 6.34c.139.138.21.31.213.514a.749.749 0 0 1-.213.54.735.735 0 0 1-.534.232.735.735 0 0 1-.535-.232L12.75 7.373V18.75a.725.725 0 0 1-.216.535.726.726 0 0 1-.534.215.726.726 0 0 1-.534-.215.725.725 0 0 1-.216-.535V7.373Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconArrowUpLine;
